
  import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
  import AspectRatioCard from '@/components/Cards/AspectRatioCard.vue';
  import SmartLink from '@/components/Common/SmartLink.vue';
  import Utils from '@/utils/utils';

  @Component({
    components: {
      AspectRatioCard,
      SmartLink,
    },
  })
  export default class QuestCard extends Vue {
    @Prop({ required: true }) readonly image!: string;

    @Prop({ required: true }) readonly to_next!: number;

    @Prop({ required: true }) readonly title!: string;

    @Prop({ required: true }) readonly desc!: string;

    @Prop({ required: true }) readonly level!: string;

    @Prop() readonly questLink?: string;

    @Prop() readonly puzzleLink?: string;

    @Prop({ required: true }) readonly current_level!: string;

    @Prop() readonly current_puzzle?: string;

    @Ref('root') readonly root!: HTMLDivElement;

    get nav() {
      return Utils.isLinkInternal(this.toGame) ? 'to' : 'href';
    }

    get toGame() {
      return (
        this.puzzleLink ||
        (this.current_puzzle &&
          `/puzzles/${this.current_puzzle}/play`) ||
        this.toQuest
      );
    }

    get toQuest() {
      return this.questLink || (this.title && `/quests/${this.title}`);
    }

    get locked() {
      return Number(this.level) - 1 > Number(this.current_level);
    }

    get started() {
      return this.to_next > 0 && !this.locked;
    }

    get completed() {
      return this.to_next >= 1 && !this.locked;
    }
  }
